import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SystemColors } from "../fundations/palette/colors";
import { getAlertToken, getBorderToken, getTextToken } from "../fundations/palette/colorTokens";
import { Corner8 } from "../fundations/shape/corners";
const SvgPrimary = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "34",
        height: "34",
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "5",
                y: "5",
                width: "24",
                height: "24",
                rx: "12",
                stroke: "#38BCF7",
                strokeOpacity: "0.64",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "1",
                y: "1",
                width: "32",
                height: "32",
                rx: "16",
                stroke: "#38BCF7",
                strokeOpacity: "0.16",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_8242_38491)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17 7.83334C11.9374 7.83334 7.83331 11.9374 7.83331 17C7.83331 22.0626 11.9374 26.1667 17 26.1667C22.0626 26.1667 26.1666 22.0626 26.1666 17C26.1666 11.9374 22.0626 7.83334 17 7.83334ZM17 12C16.5397 12 16.1666 12.3731 16.1666 12.8333C16.1666 13.2936 16.5397 13.6667 17 13.6667H17.0083C17.4685 13.6667 17.8416 13.2936 17.8416 12.8333C17.8416 12.3731 17.4685 12 17.0083 12H17ZM17.8333 16.1667C17.8333 15.7064 17.4602 15.3333 17 15.3333C16.5397 15.3333 16.1666 15.7064 16.1666 16.1667V21.1667C16.1666 21.6269 16.5397 22 17 22C17.4602 22 17.8333 21.6269 17.8333 21.1667V16.1667Z",
                    fill: "#069CDF"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_8242_38491",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(7 7)"
                    })
                })
            })
        ]
    });
const SvgError = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "34",
        height: "34",
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "5",
                y: "5",
                width: "24",
                height: "24",
                rx: "12",
                stroke: "#F86F6E",
                strokeOpacity: "0.64",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "1",
                y: "1",
                width: "32",
                height: "32",
                rx: "16",
                stroke: "#F86F6E",
                strokeOpacity: "0.16",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_8242_38650)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17 7.83334C11.9374 7.83334 7.83337 11.9374 7.83337 17C7.83337 22.0626 11.9374 26.1667 17 26.1667C22.0626 26.1667 26.1667 22.0626 26.1667 17C26.1667 11.9374 22.0626 7.83334 17 7.83334ZM20.0893 15.0893C20.4147 14.7638 20.4147 14.2362 20.0893 13.9108C19.7639 13.5853 19.2362 13.5853 18.9108 13.9108L17 15.8215L15.0893 13.9108C14.7639 13.5853 14.2362 13.5853 13.9108 13.9108C13.5853 14.2362 13.5853 14.7638 13.9108 15.0893L15.8215 17L13.9108 18.9108C13.5853 19.2362 13.5853 19.7638 13.9108 20.0893C14.2362 20.4147 14.7639 20.4147 15.0893 20.0893L17 18.1785L18.9108 20.0893C19.2362 20.4147 19.7639 20.4147 20.0893 20.0893C20.4147 19.7638 20.4147 19.2362 20.0893 18.9108L18.1786 17L20.0893 15.0893Z",
                    fill: "#EB4143"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_8242_38650",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(7 7)"
                    })
                })
            })
        ]
    });
const SvgWarning = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "36",
        height: "34",
        viewBox: "0 0 36 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M29.759 22.0296L21.7154 7.47436C20.0985 4.5486 15.8927 4.54857 14.2758 7.47436L6.23214 22.0296C4.66676 24.8622 6.71557 28.3353 9.95192 28.3353H26.0393C29.2756 28.3353 31.3244 24.8622 29.759 22.0296Z",
                stroke: "#FCB823",
                strokeOpacity: "0.64",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M33.2628 20.0948L25.2191 5.53959C22.0805 -0.139809 13.9163 -0.13992 10.7776 5.53959L2.73397 20.0948C-0.30472 25.5934 3.6724 32.3352 9.95471 32.3352H26.0421C32.3244 32.3352 36.3015 25.5934 33.2628 20.0948Z",
                stroke: "#FCB823",
                strokeOpacity: "0.16",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.2103 9.76084C19.2681 8.00317 16.748 8.00226 15.8045 9.75925L9.41841 21.6508C8.524 23.3163 9.73045 25.3336 11.6209 25.3336H24.382C26.2717 25.3336 27.4782 23.3179 26.5854 21.6524L20.2103 9.76084ZM18.8334 14.5C18.8334 14.0398 18.4603 13.6667 18.0001 13.6667C17.5398 13.6667 17.1667 14.0398 17.1667 14.5V17.8333C17.1667 18.2936 17.5398 18.6667 18.0001 18.6667C18.4603 18.6667 18.8334 18.2936 18.8334 17.8333V14.5ZM18.0001 20.3333C17.5398 20.3333 17.1667 20.7064 17.1667 21.1667C17.1667 21.6269 17.5398 22 18.0001 22H18.0084C18.4687 22 18.8417 21.6269 18.8417 21.1667C18.8417 20.7064 18.4687 20.3333 18.0084 20.3333H18.0001Z",
                fill: "#F6970A"
            })
        ]
    });
const SvgSuccess = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "34",
        height: "34",
        viewBox: "0 0 34 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "5",
                y: "5",
                width: "24",
                height: "24",
                rx: "12",
                stroke: "#40D86E",
                strokeOpacity: "0.64",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "1",
                y: "1",
                width: "32",
                height: "32",
                rx: "16",
                stroke: "#40D86E",
                strokeOpacity: "0.16",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_8242_39002)",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.83325 17C7.83325 11.9374 11.9373 7.83334 16.9999 7.83334C22.0625 7.83334 26.1666 11.9374 26.1666 17C26.1666 22.0626 22.0625 26.1667 16.9999 26.1667C11.9373 26.1667 7.83325 22.0626 7.83325 17ZM20.8964 13.8857C21.2356 14.1967 21.2585 14.7239 20.9476 15.0631L16.3642 20.0631C16.2064 20.2353 15.9835 20.3333 15.7499 20.3333C15.5163 20.3333 15.2935 20.2353 15.1356 20.0631L13.0523 17.7904C12.7413 17.4511 12.7642 16.924 13.1035 16.613C13.4428 16.302 13.9699 16.3249 14.2809 16.6642L15.7499 18.2668L19.719 13.9369C20.03 13.5976 20.5571 13.5747 20.8964 13.8857Z",
                    fill: "#26BF56"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_8242_39002",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(7 7)"
                    })
                })
            })
        ]
    });
export const Alert = {
    MuiAlert: {
        variants: [
            {
                props: {
                    severity: "primary"
                },
                style: ({ theme })=>({
                        backgroundColor: SystemColors.accentBlue[50],
                        color: getTextToken("textTertiary", theme),
                        borderColor: getBorderToken("borderColorPrimary", theme)
                    })
            },
            {
                props: {
                    severity: "info"
                },
                style: ({ theme })=>({
                        backgroundColor: getAlertToken("alertInfoColor", theme),
                        color: getTextToken("textSecondary", theme),
                        borderColor: getAlertToken("alertInfoBorder", theme)
                    })
            },
            {
                props: {
                    severity: "error"
                },
                style: ({ theme })=>({
                        backgroundColor: getAlertToken("alertErrorColor", theme),
                        color: getTextToken("textError", theme),
                        borderColor: getAlertToken("alertErrorBorder", theme)
                    })
            },
            {
                props: {
                    severity: "warning"
                },
                style: ({ theme })=>({
                        backgroundColor: getAlertToken("alertWarningColor", theme),
                        color: getTextToken("textWarning", theme),
                        borderColor: getAlertToken("alertWarningBorder", theme)
                    })
            },
            {
                props: {
                    severity: "success"
                },
                style: ({ theme })=>({
                        backgroundColor: getAlertToken("alertSuccessColor", theme),
                        color: getTextToken("textSuccess", theme),
                        borderColor: getAlertToken("alertSuccessBorder", theme)
                    })
            }
        ],
        defaultProps: {
            iconMapping: {
                primary: /*#__PURE__*/ _jsx(SvgPrimary, {}),
                success: /*#__PURE__*/ _jsx(SvgSuccess, {}),
                error: /*#__PURE__*/ _jsx(SvgError, {}),
                warning: /*#__PURE__*/ _jsx(SvgWarning, {}),
                info: /*#__PURE__*/ _jsx(SvgPrimary, {})
            }
        },
        styleOverrides: {
            root: ({ theme })=>({
                    "& .MuiAlert-icon": {
                        marginRight: theme.spacing(2),
                        padding: 0
                    },
                    "& .MuiAlert-message": {
                        padding: 0,
                        alignContent: "center"
                    },
                    "& .MuiAlert-action": {
                        padding: 0
                    },
                    padding: theme.spacing(2.5),
                    borderRadius: Corner8,
                    borderColor: getBorderToken("border200", theme),
                    borderWidth: "1px",
                    borderStyle: "solid"
                })
        }
    }
};

//# sourceMappingURL=Alert.js.map